export function flattenForEdit(company) {
  if (!company) return {};

  return {
    companyId: company.companyId,

    // Company details
    name: company.name || "",
    sector: company.sector || "",
    location: company.location || "",
    reportingCurrency: company.reportingCurrency || "",
    description: company.description || "",

    // Ownership
    partners: company.ownership?.partners || [],
    boardRepresentative: company.ownership?.boardRepresentative || "",
    fundFamily: company.ownership?.fundFamily || "",
    vintageYear: company.ownership?.vintageYear || "",
    grade: company.ownership?.grade || "",
    rank: company.ownership?.rank || "",

    // Investment
    ownershipPct: company.investment?.ownershipPct || "",
    investedCapital: company.investment?.investedCapital || "",
    currentReserves: company.investment?.currentReserves || "",
    totalCapitalBudget: company.investment?.totalCapitalBudget || "",
    currentValue: company.investment?.currentValue || "",
    realisedValue: company.investment?.realisedValue || "",
  };
}
